import React, { useState, useEffect } from "react"
import { useTranslation } from "next-i18next"
import Camera from "@/components/VisualSearch/v1/CameraView/Camera.js"
import { validateImageFileAsync } from "@/components/VisualSearch/v1/utils"
import GuildePageMobile from "@/components/VisualSearch/v1/CameraView/GuildePageMobile"
import { getTranslations } from "@/components/VisualSearch/localization"
import { getGuide } from "@/components/VisualSearch/v1/CameraView/utils"
import {
  Close,
  CaptureIcon,
  UploadIcon,
  InfoIcon,
} from "@/components/VisualSearch/v1/CameraView/icons"
import { addDataLayerVisualSearch } from "@/components/VisualSearch/analytics"
import Style from "@/components/VisualSearch/v1/CameraView/cameraview.module.scss"

const CameraView = props => {
  const {
    setImage = () => {},
    back = () => {},
    category = "",
    className = "",
    setOpenCam = () => {},
    setSection = () => {},
    setOutput = () => {},
    setEventType = () => {},
    isUsingGlobalVS = false,
    hideCloseIcon = false,
  } = props

  const [captureTrigger, setCaptureTrigger] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const { t } = useTranslation()
  const data = getTranslations(t)
  const { image, text } = getGuide(category, data)

  let heic2any = null
  useEffect(() => {
    import("heic2any").then(module => {
      heic2any = module.default
    })
  }, [])

  const processImage = input => {
    setImage(input)
    setOpenCam(false)
  }

  const handlesetResult = async event => {
    if (event?.target) {
      const file = event.target.files[0]
      let convertFile = null
      const heicType = ["image/heif", "image/heic", "heic", "heif"]
      const fileType = file?.type ? file?.type : file?.name?.split(".").at(-1)
      const isHeicimg = heicType.includes(fileType)
      if (isHeicimg) {
        const res = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.9,
        })
        convertFile = new File([res], `${file?.name?.split(".")[0]}.jpg`, {
          type: res.type,
          lastModified: new Date().getTime(),
        })
      } else {
        convertFile = file
      }
      if (convertFile) {
        const resp = await validateImageFileAsync(convertFile, heic2any)
        setEventType("browse")
        addDataLayerVisualSearch({
          eventKey: "browse",
          category: category,
          eventStatus: "interaction",
        })
        if (resp) {
          setImage(resp)
        } else {
          setSection("error")
        }
      }
    }
  }

  return showInfo ? (
    <GuildePageMobile
      category={category}
      setShowInfo={setShowInfo}
      setSection={setSection}
      setOutput={setOutput}
      isUsingGlobalVS={isUsingGlobalVS}
    />
  ) : (
    <div className={`${Style.CameraView} ${className}`}>
      <button
        className={`back-button ${hideCloseIcon && "hide-close-btn"}`}
        onClick={() => {
          back()
          setOpenCam(false)
        }}
      >
        <Close />
      </button>
      <Camera
        handlerResult={processImage}
        captureTrigger={captureTrigger}
        setCaptureTrigger={setCaptureTrigger}
      />
      {image}
      <div className="guide-text-wrapper">
        <p
          className={`${isUsingGlobalVS && "globalvs-camera-text"} guide-text`}
        >
          {text}
        </p>
      </div>
      <div
        className={`${
          isUsingGlobalVS && "globalvs-camera-view-btns"
        } button-group`}
      >
        <button
          onClick={() => {
            document.querySelector("#upload-input").click()
          }}
        >
          <input
            id="upload-input"
            className={"upload-input"}
            type="file"
            onChange={handlesetResult}
            hidden="true"
          />
          <UploadIcon />
        </button>
        <button
          onClick={() => {
            setCaptureTrigger(true)
            setEventType("capture")
            addDataLayerVisualSearch({
              eventKey: "capture",
              category: category,
              eventStatus: "interaction",
            })
          }}
        >
          <CaptureIcon />
        </button>
        <button onClick={() => setShowInfo(true)}>
          <InfoIcon />
        </button>
      </div>
    </div>
  )
}

export default CameraView
